module.exports = __webpack_public_path__ + "img/tracking.cb9ec5bf.svg";